import React, { useEffect, useMemo, useState } from "react";
import { FaChevronLeft, FaChevronRight, FaQuoteLeft, FaQuoteRight } from "react-icons/fa";
import { testimonialGrid } from "../assets/appImages";

const Testimonial = ({ testimonials }) => {
  const items = useMemo(
    () => (Array.isArray(testimonials) ? testimonials : []),
    [testimonials]
  );
  const [activeIndex, setActiveIndex] = useState(0);
  const active = items[activeIndex] || items[0];

  useEffect(() => {
    setActiveIndex(0);
  }, [items.length]);

  const goPrev = () => {
    setActiveIndex((prev) => (prev === 0 ? items.length - 1 : prev - 1));
  };

  const goNext = () => {
    setActiveIndex((prev) => (prev === items.length - 1 ? 0 : prev + 1));
  };

  if (!active || items.length === 0) return null;
console.log(active,"ative")
  return (
    <section className="bg-white py-16 md:py-20 lg:py-24">
      <svg className="absolute h-0 w-0" aria-hidden="true">
        <defs>
          <filter id="remove-black-bg" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  1 1 1 0 -0.04"
            />
          </filter>
        </defs>
      </svg>

      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="text-center">
          <p className="text-[18px] font-bold text-brand-orange">Testimonial</p>
          <h2 className="mx-auto mt-2 max-w-3xl text-3xl font-bold leading-tight text-brand-purple md:text-4xl lg:text-[2.5rem]">
            See What Are The Patients Saying About us
          </h2>
        </div>

        <div className="mt-10 grid items-center gap-6 lg:mt-14 lg:grid-cols-2 lg:gap-6">
          <div className="relative flex justify-center">
            <span
              aria-hidden="true"
              className="pointer-events-none absolute left-4 top-0 text-[48px] font-light leading-none text-brand-orange md:left-8 md:text-[56px]"
            >
              +
            </span>
            <span
              aria-hidden="true"
              className="pointer-events-none absolute bottom-6 left-6 h-14 w-14 rotate-45 rounded-sm border-2 border-[#B8C4E8] md:bottom-10 md:left-10 md:h-16 md:w-16"
            />
            <img
              src={testimonialGrid}
              alt="Patient testimonials"
              className="relative z-[1] block h-[454px] w-full max-w-[454px]"
            />
          </div>

          <div>
            <article className="relative rounded-bl-[24px] rounded-br-[24px] rounded-tl-[24px] rounded-tr-none bg-brand-orange px-6 py-8 shadow-[0_16px_40px_rgba(241,119,50,0.28)] md:px-8 md:py-10 w-[550px] h-[350px]">
              <div className="absolute left-10 top-1 flex h-12 w-12 items-center justify-center rounded-md bg-white shadow-[0_4px_16px_rgba(0,0,0,0.08)] md:-top-7">
                <FaQuoteLeft className="text-[24px] text-brand-orange" aria-hidden="true" />
              </div>

              <p className="mt-4 text-[18px] font-normal italic leading-[1.85] text-white md:mt-2 md:text-[16px]">
                {active.quote}
              </p>

              <div className="mt-8">
                <p className="text-[18px] font-semibold text-white md:text-[22px]">{active.name}</p>
                <p className="mt-1 text-[14px] font-medium tracking-wide text-white/90">
                  {active.role}
                </p>
              </div>

              <span
                aria-hidden="true"
                className="pointer-events-none absolute bottom-4 right-4 select-none text-[96px] font-serif leading-none text-white/20 md:bottom-6 md:right-6 md:text-[120px]"
              >
                <FaQuoteRight />
              </span>
            </article>

            <div className="mt-5 flex items-center gap-3">
              <button
                type="button"
                onClick={goPrev}
                aria-label="Previous testimonial"
                className="flex h-10 w-10 items-center justify-center rounded-md bg-[#FAD9C8] text-brand-orange transition-opacity hover:opacity-80"
              >
                <FaChevronLeft className="text-[14px]" />
              </button>
              <button
                type="button"
                onClick={goNext}
                aria-label="Next testimonial"
                className="flex h-10 w-10 items-center justify-center rounded-md bg-[#FAD9C8] text-brand-orange transition-opacity hover:opacity-80"
              >
                <FaChevronRight className="text-[14px]" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
